import { render, staticRenderFns } from "./OrganisationAppraisal.vue?vue&type=template&id=88b90b32"
import script from "./OrganisationAppraisal.vue?vue&type=script&lang=js"
export * from "./OrganisationAppraisal.vue?vue&type=script&lang=js"
import style0 from "./OrganisationAppraisal.vue?vue&type=style&index=0&id=88b90b32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports